import React, { Fragment, useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import axios from "axios";

const AdminResetPassword = ({ selectedUser, showDialog, setShowDialog }) => {
  const [passwordIn, setPasswordIn] = useState("");
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);
  const [passwordChanged, setPasswordChanged] = useState("waiting");

  useEffect(() => {
    if (showDialog === true) {
      setPasswordIn("");
      setLoading(false);
      setPasswordChanged("waiting");
    }
  }, [showDialog]);

  useEffect(() => {
    setUser(selectedUser);
  }, [selectedUser]);

  const handleResetPassword = async () => {
    let body = {
      id: user._id,
      password: passwordIn,
    };

    setLoading(true);
    try {
      setLoading(false);

      const res = await axios.patch("/api/v1/users/admin-reset", body, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });

      if (res.data.data === "passed") {
        setPasswordChanged("passed");
        setLoading(false);
      }
    } catch (err) {
      setPasswordChanged("error");
      setLoading(false);
      // Need to put message that an error occurred
    }
  };

  const handleInputChange = (e) => {
    setPasswordIn(e.target.value);
    // setEmailError(false);
  };

  const hideDialog = () => {
    setShowDialog(false);
  };

  return (
    <Fragment>
      {user !== null && (
        <Dialog
          header='Reset Password'
          footer=''
          visible={showDialog}
          style={{ width: "30vw" }}
          onHide={hideDialog}
          baseZIndex={1000}
        >
          <Fragment>
            <div className='p-fluid p-grid p-dir-col'>
              <div className='p-field p-col-12'>
                <div className='font-l-bold h-48px'>
                  <p>{user !== null && `Reset password for ${user.email}`}</p>
                </div>
                <label htmlFor='password'>New Password</label>
                <InputText
                  id='new-password'
                  name='passwordIn'
                  value={passwordIn}
                  onChange={handleInputChange}
                  disabled={false}
                />
                <div className='h-42px'>
                  {passwordChanged === "passed" ? (
                    <p className='font-l k-pt-10px'>
                      The password has been changed.
                    </p>
                  ) : passwordChanged === "error" ? (
                    <p className='font-l k-pt-10px'>
                      An error occurred and the password was not changed.
                    </p>
                  ) : (
                    passwordIn.length < 8 && (
                      <p className='font-l k-pt-10px'>
                        password must be at least 8 characters
                      </p>
                    )
                  )}
                </div>
              </div>
            </div>
            <div className='p-d-flex p-jc-evenly'>
              <Button
                onClick={hideDialog}
                label='Close'
                className='p-button-warning'
                disabled={loading && passwordChanged !== "waiting"}
              />
              <Button
                onClick={handleResetPassword}
                label='Update'
                className='p-button-success'
                loadingIcon='pi pi-spin pi-sun'
                loading={loading || passwordChanged !== "waiting"}
                disabled={passwordIn.length < 8}
              />
            </div>
          </Fragment>
        </Dialog>
      )}
    </Fragment>
  );
};

export default AdminResetPassword;
